import React from 'react';
import styles from './index.css';
import offline from './offline.png';

export default () => (
  <div
    id={styles.root}
  >
    <img
      src={offline}
      alt="offline"
      width="150"
      height="150"
    />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/App/Offline/index.jsx